var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1667 13.5L24.0833 3L6 13.5V34.5L24.0833 45L42.1667 34.5V13.5ZM40.1615 14.6667L24.0875 5.33333L8.01338 14.6667V33.3333L24.0875 42.6667L40.1615 33.3333V14.6667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0648 7.67004L38.1297 15.8367V32.17L24.0648 40.3367L10 32.17V15.8367L24.0648 7.67004ZM15.72 15H32.28C32.6783 15 33 15.3218 33 15.72V32.28C33 32.6783 32.6783 33 32.28 33H15.72C15.3218 33 15 32.6783 15 32.28V15.72C15 15.3218 15.3218 15 15.72 15ZM16.62 31.38H31.38V16.62H16.62V31.38ZM20.4788 24.27H19.338C19.2525 24.27 19.185 24.2025 19.185 24.1125V22.3373C19.185 21.093 20.1885 20.085 21.4283 20.085H26.0588V18.8835C26.0588 18.7575 26.205 18.6855 26.304 18.7642L28.7588 20.6925C28.8375 20.7533 28.8375 20.8725 28.7588 20.9333L26.304 22.8615C26.205 22.9403 26.0588 22.8705 26.0588 22.7423V21.5408H21.4305C20.9895 21.5408 20.6318 21.8985 20.6318 22.3418V24.117C20.6318 24.2025 20.562 24.27 20.4788 24.27ZM21.6983 29.2335L19.2435 27.3053C19.1648 27.2445 19.1648 27.1253 19.2435 27.069L21.6983 25.1408C21.7973 25.062 21.9435 25.1318 21.9435 25.26V26.4615H26.5695C27.0105 26.4615 27.3682 26.1038 27.3682 25.6605V23.8853C27.3682 23.7997 27.438 23.7323 27.5212 23.7323H28.662C28.7475 23.7323 28.815 23.802 28.815 23.8853V25.6605C28.815 26.9048 27.8115 27.9128 26.5718 27.9128H21.9435V29.1143C21.9435 29.2402 21.7973 29.3123 21.6983 29.2335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngagementIcon);
export default __webpack_public_path__ + "static/media/Engagement_Icon.c1103739d64b2f64ac2fa6e2e3b7fdb6.svg";
export { ForwardRef as ReactComponent };